window.Collections = new function()
{
    this.vars = {
      token: jQuery('meta[name="csrf-token"]').attr('content')
    };

    this.init = function() {
        jQuery('body').on('change', '.change-collection-visibility', function(event) {
            event.preventDefault();
            Collections.changeVisibility(this);
        });

        jQuery('body').on('click', '.add-post-to-collection', function(event) {
            var post_id = jQuery(this).data('post-id');
            jQuery(this).addClass('red');
            Collections.bookmarkPost(post_id);
        });

        jQuery('body').on('click', '#add-post-to-collection-modal .create-collection-link', function(event){
            jQuery('#add-post-to-collection-modal .new-collection-field').show();
        });

        jQuery('body').on('click', '#add-post-to-collection-modal .cancel-new-collection', function(event){
            jQuery('#add-post-to-collection-modal .new-collection-field').hide();
            jQuery('#add-post-to-collection-modal input.new-collection-field').val('');
        });

        jQuery('body').on('click', '#add-post-to-collection-modal .bookmark-icon', function(event){
            jQuery(this).toggleClass('active');

            if(jQuery('#add-post-to-collection-modal input.bookmark-input').is(':checked')) {
                jQuery('#add-post-to-collection-modal input.bookmark-input').prop('checked', false);
            } else {
                jQuery('#add-post-to-collection-modal input.bookmark-input').prop('checked', true);
            }
        });

        jQuery('body').on('click', '.collection-plus', function () {
            var checkbox = jQuery(this).closest('li').find('.collection-input');

            if (checkbox.prop('checked')) {
                checkbox.prop('checked', false);
                jQuery(this).find('i').attr('class','fa-regular fa-plus');
            } else {
                checkbox.prop('checked', true);
                jQuery(this).find('i').attr('class','fa-solid fa-square-check');
            }
        });

        jQuery('body').on('submit', 'form.add-post-collection-form', function(event) {
            event.preventDefault();
            
            var form      = jQuery(this);
            var url       = form.attr('action');
            var form_data = form.serialize();
            
            $.ajax({
                url: url,
                type: 'POST',
                data: form_data,
                showloader: true,
                success: function(response) {
                    jQuery('#add-post-to-collection-modal').modal('hide');
                    FunMain.flashNotification('success', 'Collection Updated');
                }
            });
        });
    };

    /**
     * Bookmarks a post immediately when the add to collection button is clicked
     *
     * @param int post_id
     */
    this.bookmarkPost = function(post_id) {
        $.ajax({
            url: '/posts/read-later',
            type: 'POST',
            data: {
                post_id: post_id,
                _token: SavePost.vars.token
            }
        });
    };

    /**
     * Change visibility of a collection
     *
     * @param obj el - select box changed
     */
    this.changeVisibility = function(el) {
        var collection_id = jQuery(el).data('id');
        var status        = jQuery(el).find('option:selected').val();

        $.ajax({
            url: '/collections/collection/quick-change-status',
            type: 'POST',
            data: {
                status:status,
                collection_id:collection_id,
                _token: Collections.vars.token
            },
            showloader: true,
            success: function(response) { 
                jQuery(el).closest('li.collection').find('.collection-link em').text(response);
            }
        });
    };
}

jQuery(document).ready(function($) {
    Collections.init();
});
